import { useCallStore } from '../stores/call-store';
import { CallControls } from './CallControls';
import { useCallManager } from '../hooks/useCallManager';

export function ActiveCalls() {
  const sipSessions = useCallStore((state) => state.sipSessions);
  const activeCalls = useCallStore((state) => state.activeCalls);
  const { answerCall } = useCallManager();

  const sessionsArray = Array.from(sipSessions.values());

  if (sessionsArray.length === 0) {
    return (
      <div className="active-calls empty">
        <p>No active calls</p>
      </div>
    );
  }

  const handleAnswer = async (sessionId: string) => {
    try {
      await answerCall(sessionId);
    } catch (error) {
      console.error('Failed to answer call:', error);
    }
  };

  return (
    <div className="active-calls">
      <h3>Active Calls</h3>
      <div className="active-calls-list">
        {sessionsArray.map((session) => {
          const isRinging =
            session.direction === 'inbound' && session.state !== 'Established';

          const matchingCall = Array.from(activeCalls.values()).find(
            (call) => call.status !== 'completed' && call.status !== 'failed'
          );

          return (
            <div key={session.id} className="active-call-item">
              {isRinging ? (
                <div className="incoming-call">
                  <div className="caller-info">
                    <div className="caller-icon">📞</div>
                    <div className="caller-details">
                      <div className="caller-number">{session.remoteIdentity}</div>
                      <div className="call-status">Incoming call...</div>
                    </div>
                  </div>
                  <div className="incoming-call-actions">
                    <button
                      onClick={() => handleAnswer(session.id)}
                      className="answer-button"
                    >
                      Answer
                    </button>
                  </div>
                </div>
              ) : (
                <CallControls
                  sessionId={session.id}
                  callUUID={matchingCall?.call_uuid}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
